import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { setDefaultSetting, setIsLoading } from "../store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { editSale } from "./helper";

export function useSyncDefaultSettingSaleMode(data: any, defaultSetting: any) {
    useEffect(() => {
        if (data.data === undefined) return;
        setDefaultSetting({
            ...defaultSetting,
            saleMode: { data: [...data.data] },
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
}

export function useSaleModeModified(
    isSaleModeModified: any,
    skipFirstEffect: boolean,
    setSkipFirstEffect: (val: boolean) => void,
    franchiseID: string,
    saleMode: any,
    setIsAddSaleClicked: (val: boolean) => void,
    setDataIsUpdated: Function,
    dataIsUpdated: boolean | number,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    useEffect(() => {
        if (skipFirstEffect) {
            setIsLoading(true);
            editSale(
                franchiseID,
                saleMode,
                setIsAddSaleClicked,
                setDataIsUpdated,
                dataIsUpdated,
                fetchGlobal
            );
        } else setSkipFirstEffect(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSaleModeModified]);
}

export function useInitSaleModeUrl(
    franchiseID: string,
    setUrl: (url: string) => void
) {
    useEffect(() => {
        setUrl(
            `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/getData?type=saleMode&franchiseId=${franchiseID}`
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useInitSaleForm(
    dataSale: any,
    i18nextLng: string,
    setSaleMode: (val: string) => void,
    setTagsData: (val: any) => void,
    setDisplayName: (val: string) => void,
    setSalesSupport: (val: any) => void,
    setAdvancedDisplayName: (val: any) => void,
    setTitle: (val: string) => void,
    updateSalesSupportData: (saleMode: string) => void
) {
    const { t } = useTranslation();

    useEffect(() => {
        clearMultiCustomSelectionData();
        clearData();
        setTitle(t("Modify a sales method"));
        setSaleMode(dataSale["Mode of sale"] ?? dataSale.designation);
        setTagsData(dataSale.tag);
        setDisplayName(dataSale.advancedDisplayName.languages[i18nextLng]);
        setSalesSupport(dataSale.support_vente);
        setAdvancedDisplayName(dataSale.advancedDisplayName);
        updateSalesSupportData(
            dataSale["Mode of sale"] ?? dataSale.designation
        );
        // eslint-disable-next-line
    }, [dataSale, t]);
}
